import {Model} from "./Model";

export const usingVarJsonMap: any = (target: any): void => {
    Object.defineProperty(target, "mapJsonAndVariables", {
        value: null,
        writable: true,
        enumerable: true,
        configurable: true
    });
}

export function usingJsonToModelConvertor<T extends { new(...args: any[]): {} }>(constructor: T) {
    const isModel = constructor.prototype instanceof Model;
    if (!isModel)
        throw "JSON models should extend Model abstract class";
    // @ts-ignore
    return class extends constructor {
        constructor(json: any) {
            super(json);
            // @ts-ignore
            this.specifyAll();
        }
    }
}

export const fromJsonObject: any = ({key, modelClass = undefined, isArray = false}: decoratorParams) => {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor): void {
        target.addVariableAndKey(propertyKey, key, modelClass, isArray);
    };
}

export interface decoratorParams {
    key: string,
    modelClass: Model|undefined,
    isArray: boolean
}


export const classAddress: any = (address: object) => {
    return function (target: any, propertyKey: string, descriptor: PropertyDescriptor): void {
        target.addClassAddress(propertyKey, address);
    };
}

